import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { Section } from "@/components/Section";
import { KeyIdea, Tip } from "@/components/Callouts";

export default function EdSheeran1() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "1");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section title="Chord Chart">
        <NoteImage
          src="/notes/ed-sheeran/finals/01-opening.png"
          caption="Jason's chord chart for Opening"
        />
      </Section>

      <Section title="Intro Harmony">
        <RomanNumeralAnalysis
          label="Intro · D♭ major — D♭5 held, then the turnaround"
          chords={[
            { chord: "Db5", rn: "I5", function: "Tonic", pitches: ["Db2", "Ab2", "Db3"] },
            { bar: true },
            { chord: "Bbm", rn: "vi", function: "Submediant", pitches: ["Bb2", "Db3", "F3", "Bb3"] },
            { chord: "Ab", rn: "V", function: "Dominant", pitches: ["Ab2", "C3", "Eb3", "Ab3"] },
            { bar: true },
            { chord: "Db", rn: "I", function: "Tonic", pitches: ["Db3", "F3", "Ab3", "Db4"] },
            { chord: "Db/F", rn: "I⁶", function: "Tonic", pitches: ["F2", "Db3", "F3", "Ab3"] },
            { bar: true },
            { chord: "F#", rn: "IV", function: "Pre-dominant", pitches: ["F#2", "A#2", "C#3", "F#3"] },
            { chord: "Db", rn: "I", function: "Tonic", pitches: ["Db3", "F3", "Ab3", "Db4"] },
          ]}
        />
        <Tip>
          B♭m is the relative minor of D♭ major — the two keys share all seven notes. The two
          chords themselves share two notes, D♭ and F, which is why B♭m can stand in for D♭ so
          smoothly.
        </Tip>
      </Section>

      <Section title="Chorus">
        <RomanNumeralAnalysis
          label="Chorus · D♭ major"
          chords={[
            { chord: "Db/F", rn: "I⁶", function: "Tonic", pitches: ["F2", "Db3", "F3", "Ab3"] },
            { chord: "F#", rn: "IV", function: "Pre-dominant", pitches: ["F#2", "A#2", "C#3", "F#3"] },
            { bar: true },
            { chord: "Db", rn: "I", function: "Tonic", pitches: ["Db3", "F3", "Ab3", "Db4"] },
            { chord: "Ab", rn: "V", function: "Dominant", pitches: ["Ab2", "C3", "Eb3", "Ab3"] },
          ]}
        />
        <KeyIdea title="F♯ is really G♭">
          Jason writes this chord as F♯. In D♭ major it is the IV chord, G♭ (G♭–B♭–D♭) — the
          same three keys on the piano as F♯–A♯–C♯. So it is not borrowed: it belongs to the key.
          With D♭/F in the bass, the line steps up F → G♭ (F♯) by a half step.
        </KeyIdea>
      </Section>

      <Section title="Watch">
        <YouTubeEmbed videoId="lAxW0CSUdIY" />
      </Section>
    </LessonShell>
  );
}
